import { getFixedT } from '@/hooks/useTranslation';



export const taleScanDomains = {
  marketing: { universeId: 'marketing_consumer_insights', nameFr: 'Marketing / Insights Consommateurs' },
  rh: { universeId: 'hr_employee_insights', nameFr: 'RH / Insights Collaborateurs' },
  b2b: { universeId: 'b2b_business_insights', nameFr: 'B2B / Insights Entreprises' },
  opinion: { universeId: 'public_opinion_insights', nameFr: 'Opinion publique / Insights Public' },
  innovation: { universeId: 'innovation', nameFr: 'Innovation' },
  evaluation: { universeId: 'evaluation_programs_projects', nameFr: 'Évaluation / Programmes / Projets' },
  communication: { universeId: 'communication_institutional', nameFr: 'Communication / Institutionnel' },
};


const MOCK_MODES = ['hide', 'soon', 'show'];
const RAW_MOCK_MODE = (process.env.REACT_APP_TALESCAN_MOCK_MODE || '').trim().toLowerCase();
export const MOCK_MODE = MOCK_MODES.includes(RAW_MOCK_MODE) ? RAW_MOCK_MODE : 'hide';

/** La catégorie peut-elle lancer une conversation avec l'agent ? */
export const isPlayable = (problem) => Boolean(problem) && (!problem.isMock || MOCK_MODE === 'show');

export const taleScanProblems = [
  // marketing — marketing_consumer_insights
  { problemId: 'mkt_buying', domainId: 'marketing', isMock: false, category: 'GENERAL_MARKET_RESEARCH',
    tagFr: "Achat", keyQuestionFr: "Pourquoi les gens achètent-ils ou n'achètent-ils pas ?" },
  { problemId: 'mkt_brand', domainId: 'marketing', isMock: false, category: 'BRAND_TRACKING_OR_AWARENESS',
    tagFr: "Marque", keyQuestionFr: "Comment la marque est-elle perçue ?" },
  { problemId: 'mkt_customer_experience', domainId: 'marketing', isMock: false,
    tagFr: "Expérience Client", keyQuestionFr: "Comment l'expérience client/consommateur est-elle vécue ?" },
  { problemId: 'mkt_satisfaction', domainId: 'marketing', isMock: false,
    tagFr: "Satisfaction", keyQuestionFr: "Dans quelle mesure les attentes sont-elles satisfaites ?" },
  { problemId: 'mkt_usage', domainId: 'marketing', isMock: false,
    tagFr: "Usage", keyQuestionFr: "Comment, quand et pourquoi le produit/service est-il utilisé ?" },
  { problemId: 'mkt_loyalty', domainId: 'marketing', isMock: false,
    tagFr: "Fidélité", keyQuestionFr: "Pourquoi les gens restent-ils fidèles ou envisagent-ils de changer ?" },
  { problemId: 'mkt_price', domainId: 'marketing', isMock: false,
    tagFr: "Prix", keyQuestionFr: "Le prix est-il acceptable et cohérent avec la valeur perçue ?" },
  { problemId: 'mkt_concept', domainId: 'marketing', isMock: false,
    tagFr: "Concept", keyQuestionFr: "Le concept répond-il à un besoin et montre-t-il du potentiel ?" },

  // rh — hr_employee_insights
  { problemId: 'hr_employee_experience', domainId: 'rh', isMock: false,
    tagFr: "Expérience Collaborateur", keyQuestionFr: "Comment l'expérience collaborateur est-elle vécue ?" },
  { problemId: 'hr_engagement', domainId: 'rh', isMock: false,
    tagFr: "Engagement", keyQuestionFr: "Dans quelle mesure les collaborateurs sont-ils engagés ?" },
  { problemId: 'hr_employee_satisfaction', domainId: 'rh', isMock: false,
    tagFr: "Satisfaction Collaborateur", keyQuestionFr: "Quel est le niveau de satisfaction ?" },
  { problemId: 'hr_motivation', domainId: 'rh', isMock: false,
    tagFr: "Motivation", keyQuestionFr: "Qu'est-ce qui motive ou démotive ?" },
  { problemId: 'hr_onboarding', domainId: 'rh', isMock: false,
    tagFr: "Intégration", keyQuestionFr: "Comment l'intégration est-elle vécue ?" },
  { problemId: 'hr_training', domainId: 'rh', isMock: false,
    tagFr: "Formation", keyQuestionFr: "Quels sont les besoins de formation et quelle valeur est perçue ?" },
  { problemId: 'hr_internal_communication', domainId: 'rh', isMock: false,
    tagFr: "Communication Interne", keyQuestionFr: "La communication interne est-elle comprise et utile ?" },
  { problemId: 'hr_retention', domainId: 'rh', isMock: false,
    tagFr: "Rétention", keyQuestionFr: "Pourquoi les gens restent-ils ou partent-ils ?" },

  // b2b — b2b_business_insights
  { problemId: 'b2b_needs', domainId: 'b2b', isMock: false,
    tagFr: "Besoins B2B", keyQuestionFr: "Quels besoins professionnels sont insuffisamment couverts ?" },
  { problemId: 'b2b_buying_process', domainId: 'b2b', isMock: false,
    tagFr: "Processus d'Achat", keyQuestionFr: "Comment se déroule le processus d'achat ?" },
  { problemId: 'b2b_decision_makers', domainId: 'b2b', isMock: false,
    tagFr: "Décideurs", keyQuestionFr: "Qui influence et qui décide ?" },
  { problemId: 'b2b_supplier_selection', domainId: 'b2b', isMock: false,
    tagFr: "Sélection des Fournisseurs", keyQuestionFr: "Quels critères déterminent le choix ?" },
  { problemId: 'b2b_customer_experience', domainId: 'b2b', isMock: false,
    tagFr: "Expérience Client", keyQuestionFr: "Comment l'expérience avec le fournisseur est-elle vécue ?" },
  { problemId: 'b2b_satisfaction', domainId: 'b2b', isMock: false,
    tagFr: "Satisfaction B2B", keyQuestionFr: "Quel est le niveau de satisfaction ?" },
  { problemId: 'b2b_retention', domainId: 'b2b', isMock: false,
    tagFr: "Rétention", keyQuestionFr: "Pourquoi le client reste-t-il ou change-t-il de fournisseur ?" },
  { problemId: 'b2b_value_proposition', domainId: 'b2b', isMock: false,
    tagFr: "Proposition de Valeur", keyQuestionFr: "Quelle valeur est réellement perçue ?" },

  // opinion — public_opinion_insights
  { problemId: 'pub_opinion', domainId: 'opinion', isMock: false,
    tagFr: "Opinion", keyQuestionFr: "Quelle est l'opinion sur un sujet ?" },
  { problemId: 'pub_perception', domainId: 'opinion', isMock: false,
    tagFr: "Perception", keyQuestionFr: "Comment une institution ou une personne est-elle perçue ?" },
  { problemId: 'pub_trust', domainId: 'opinion', isMock: false,
    tagFr: "Confiance", keyQuestionFr: "Quel niveau de confiance existe ?" },
  { problemId: 'pub_priorities', domainId: 'opinion', isMock: false,
    tagFr: "Priorités", keyQuestionFr: "Quelles sont les priorités ?" },
  { problemId: 'pub_intentions', domainId: 'opinion', isMock: false,
    tagFr: "Intentions", keyQuestionFr: "Quelles intentions peut-on identifier ?" },
  { problemId: 'pub_satisfaction', domainId: 'opinion', isMock: false,
    tagFr: "Satisfaction Publique", keyQuestionFr: "Quel est le niveau de satisfaction vis-à-vis d'un service ou d'une action ?" },
  { problemId: 'pub_awareness', domainId: 'opinion', isMock: false,
    tagFr: "Notoriété", keyQuestionFr: "Quel est le niveau de notoriété ?" },
  { problemId: 'pub_acceptability', domainId: 'opinion', isMock: false,
    tagFr: "Acceptabilité / Soutien", keyQuestionFr: "Dans quelle mesure une proposition est-elle acceptée ?" },

  // innovation — innovation
  { problemId: 'inn_new_needs', domainId: 'innovation', isMock: true,
    tagFr: "Nouveaux besoins", keyQuestionFr: "Quels nouveaux besoins émergent ?" },
  { problemId: 'inn_concept_potential', domainId: 'innovation', isMock: true,
    tagFr: "Concepts", keyQuestionFr: "Quelles idées ou quels concepts montrent du potentiel ?" },
  { problemId: 'inn_adoption', domainId: 'innovation', isMock: true,
    tagFr: "Adoption", keyQuestionFr: "Qui adopterait l'innovation et comment ?" },
  { problemId: 'inn_barriers', domainId: 'innovation', isMock: true,
    tagFr: "Freins", keyQuestionFr: "Qu'est-ce qui freine l'adoption ?" },
  { problemId: 'inn_prioritization', domainId: 'innovation', isMock: true,
    tagFr: "Priorisation", keyQuestionFr: "Quelles innovations faut-il prioriser ?" },

  // evaluation — evaluation_programs_projects
  { problemId: 'eval_beneficiaries', domainId: 'evaluation', isMock: true,
    tagFr: "Bénéficiaires", keyQuestionFr: "Qui sont les bénéficiaires et de quoi ont-ils besoin ?" },
  { problemId: 'eval_relevance', domainId: 'evaluation', isMock: true,
    tagFr: "Pertinence", keyQuestionFr: "Le programme répond-il à des besoins réels ?" },
  { problemId: 'eval_satisfaction', domainId: 'evaluation', isMock: true,
    tagFr: "Satisfaction", keyQuestionFr: "Les bénéficiaires sont-ils satisfaits du programme ?" },
  { problemId: 'eval_experience', domainId: 'evaluation', isMock: true,
    tagFr: "Expérience", keyQuestionFr: "Comment la participation au programme est-elle vécue ?" },
  { problemId: 'eval_effectiveness', domainId: 'evaluation', isMock: true,
    tagFr: "Efficacité", keyQuestionFr: "Le programme atteint-il ses objectifs ?" },
  { problemId: 'eval_impact', domainId: 'evaluation', isMock: true,
    tagFr: "Impact", keyQuestionFr: "Quels changements durables le programme a-t-il produits ?" },

  // communication — communication_institutional
  { problemId: 'comm_reputation', domainId: 'communication', isMock: true,
    tagFr: "Réputation", keyQuestionFr: "Comment la réputation de l'organisation est-elle perçue ?" },
  { problemId: 'comm_message_comprehension', domainId: 'communication', isMock: true,
    tagFr: "Compréhension du message", keyQuestionFr: "Le message est-il compris comme prévu ?" },
  { problemId: 'comm_campaign_effectiveness', domainId: 'communication', isMock: true,
    tagFr: "Efficacité des campagnes", keyQuestionFr: "La communication touche-t-elle et convainc-t-elle son public ?" },
  { problemId: 'comm_stakeholder_perception', domainId: 'communication', isMock: true,
    tagFr: "Parties prenantes", keyQuestionFr: "Comment les parties prenantes clés perçoivent-elles l'organisation ?" },
  { problemId: 'comm_channels_media', domainId: 'communication', isMock: true,
    tagFr: "Canaux et médias", keyQuestionFr: "Quels canaux et médias touchent le mieux le public ?" },
];

/**
 * Catégorie du survey côté backend (enum Java com.tale.shared.enums.Category) — OBLIGATOIRE :
 * une valeur absente provoque « 400 No enum constant com.tale.shared.enums.Category. ».
 * Valeur explicite sur le problème si elle existe, sinon valeur par défaut.
 * TODO : affiner par univers une fois la liste complète de l'enum connue.
 */
export const DEFAULT_SURVEY_CATEGORY = 'GENERAL_MARKET_RESEARCH';
export const getSurveyCategory = (problem) => problem?.category || DEFAULT_SURVEY_CATEGORY;

export const getProblemById = (problemId) =>
    taleScanProblems.find((p) => p.problemId === problemId) ?? null;

/** Problèmes affichés pour un domaine : sans les mock en mode 'hide'. */
export const getVisibleProblems = (domainId, problems = taleScanProblems) =>
    problems.filter((p) => p.domainId === domainId && (MOCK_MODE !== 'hide' || !p.isMock));

/** Un domaine est ouvrable s'il contient au moins une catégorie jouable. */
export const isDomainPlayable = (domainId, problems = taleScanProblems) =>
    getVisibleProblems(domainId, problems).some(isPlayable);

/** Libellés : traduction si elle existe, sinon libellé français de l'agent. */
export const getProblemLabels = (problemId, t) => {
  const problem = getProblemById(problemId);
  const tr = (key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
  };
  return {
    question: tr(`surveyBuilder.taleScan.problems.items.${problemId}.question`, problem?.keyQuestionFr ?? problemId),
    templateName: tr(`surveyBuilder.taleScan.problems.items.${problemId}.templateName`, problem?.tagFr ?? ''),
  };
};

// ---------------------------------------------------------------------------
// Banques de questions statiques (avant l'agent) — conservées pour compatibilité.
// Les clés i18n existantes restent sous les anciens identifiants (buying, brand).
// ---------------------------------------------------------------------------

const LEGACY_BANK_ID = { mkt_buying: 'buying', mkt_brand: 'brand' };

const CORE_QUESTIONS_BY_PROBLEM = {
  buying: [
    { key: 'q1', responseType: 'single_choice' },
    { key: 'q2', responseType: 'multiple_choice' },
    { key: 'q3', responseType: 'multiple_choice' },
    { key: 'q4', responseType: 'single_choice' },
    { key: 'q5', responseType: 'multiple_choice' },
    { key: 'q6', responseType: 'scale' },
    { key: 'q7', responseType: 'scale' },
    { key: 'q8', responseType: 'multiple_choice' },
  ],
  brand: [
    { key: 'q1', responseType: 'single_choice', optionKeys: ['o1', 'o2', 'o3', 'o4'] },
    { key: 'q2', responseType: 'rating_1_5' },
    { key: 'q3', responseType: 'rating_1_5' },
    { key: 'q4', responseType: 'rating_1_5' },
    { key: 'q5', responseType: 'rating_1_5' },
    { key: 'q6', responseType: 'single_choice', optionKeys: ['o1', 'o2', 'o3', 'o4', 'o5', 'o6'] },
    { key: 'q7', responseType: 'emoji_scale' },
    { key: 'q8', responseType: 'single_choice_other', optionKeys: ['o1', 'o2', 'o3', 'o4', 'o5', 'o6'] },
    { key: 'q9', responseType: 'single_choice', optionKeys: ['o1', 'o2', 'o3', 'o4', 'o5', 'o6'] },
    { key: 'q10', responseType: 'scale' },
    { key: 'q11', responseType: 'open_text' },
  ],
};

const QUESTION_BANKS_NAMESPACE = 'surveyBuilder.taleScan.questionBanks';

const resolveWithFrenchFallback = (key, t, frenchT) => {
  const value = t(key);
  return value === key ? frenchT(key) : value;
};

const resolveCoreQuestion = (bankId, meta, t, frenchT) => {
  const base = `${QUESTION_BANKS_NAMESPACE}.${bankId}.${meta.key}`;
  const question = {
    text: resolveWithFrenchFallback(`${base}.text`, t, frenchT),
    responseType: meta.responseType,
  };
  if (meta.optionKeys) {
    question.options = meta.optionKeys.map((optionKey) =>
        resolveWithFrenchFallback(`${base}.options.${optionKey}`, t, frenchT)
    );
  }
  return question;
};

const contextualize = (question, context, t, frenchT) => ({
  ...question,
  text: question.text.replace(
      '{product}',
      context?.product?.trim() || resolveWithFrenchFallback(`${QUESTION_BANKS_NAMESPACE}.defaultProductLabel`, t, frenchT)
  ),
});

export const getCoreQuestions = (problemId, context = {}, t) => {
  const frenchT = getFixedT('fr');
  const resolvedT = t ?? frenchT;
  const bankId = LEGACY_BANK_ID[problemId] ?? problemId;
  const bank = CORE_QUESTIONS_BY_PROBLEM[bankId] ?? [];
  return bank
      .map((meta) => resolveCoreQuestion(bankId, meta, resolvedT, frenchT))
      .map((q) => contextualize(q, context, resolvedT, frenchT));
};

const RESPONSE_TYPE_TO_FORMAT = {
  single_choice: 'radio',
  multiple_choice: 'checkbox',
  single_choice_other: 'radio',
  rating_1_5: 'star',
  scale: '1-10',
  emoji_scale: 'smile',
  open_text: 'comment',
};

export const toSurveyQuestion = (question) => {
  const needsOptions = ['radio', 'checkbox'].includes(RESPONSE_TYPE_TO_FORMAT[question.responseType]);
  const hasOptions = Array.isArray(question.options) && question.options.length > 0;
  const format = needsOptions && !hasOptions ? 'comment' : RESPONSE_TYPE_TO_FORMAT[question.responseType] ?? 'comment';

  return {
    id: crypto.randomUUID(),
    question_text: question.text,
    format,
    responseType: 'TEXT',
    possible_responses: format === 'radio' || format === 'checkbox' ? question.options : [],
    assets: [],
  };
};